module.exports = ".actions-col{width:120px;text-align:center}.repo-template{white-space:nowrap;width:100%}"